export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.woff?8b892b7904a39e37c53dc5a7534bb60e";